import { AppTextInput } from "../../ui/input";
import { AuthShowPassword } from "../AuthShowPassword";
import { useResetPasswordContext } from "./ResetPasswordProvider";
import React, { useState } from "react";
import { debounce } from "../../../../lib/generic";

export const ResetPasswordConfirmInput = () => {
  const { state, dispatch } = useResetPasswordContext();
  const [showPassword, setShowPassword] = useState(false);

  const debouncePassword = debounce((confirmPassword: string) => {
    dispatch({ confirmPassword: confirmPassword });
  }, 500);

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({ passwordError: "" });

    debouncePassword(event.target.value);
  };

  return (
    <AppTextInput
      label={"Confirm your password"}
      value={state.password}
      error={!!state.passwordError}
      helperText={state.passwordError}
      type={showPassword ? "text" : "password"}
      onChange={handlePasswordChange}
      endIcon={
        <AuthShowPassword
          showPassword={showPassword}
          setShowPassword={setShowPassword}
        />
      }
    />
  );
};
